<template>
  <div class="upload-reports">

    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#icon-lianmengyingxiao" fill="#fff"></use>
      </svg>
    </breadcrumbs>

    <pulic-report-notice v-if="showNotice" :class="'rule'" type="urgent" @click="closeNotice">
      <template #title>Notice: To ensure your data is counted before the CPC campaign ends, we recommend uploading data on a weekly
        basis.</template>
      <template #close></template>
    </pulic-report-notice>
    <div class="content-wrapper">
      <div class="top-title">
        <div class="top-title-left">
          <a-typography-title style="margin-bottom: 0;" :level="5">Upload Reports</a-typography-title>

          <a-popover class="wenhao-icon-wrap">
            <svg class="wenhao-icon icon" aria-hidden="true">
              <use xlink:href="#icon-wenhao-tianchong"></use>
            </svg>
            <template #content>
              <p class="tooltip-text">
                Please upload the Linked Product Report CSV file downloaded from Amazon Associates Central under: Reports → Summary.
              </p>
            </template>
          </a-popover>
        </div>
        <div class="top-title-right">
          <artmisads-select-button @click="goAssociateTags">Edit Amazon Associate StorelD</artmisads-select-button>
          <a-popover class="wenhao-icon-wrap" placement="left">
            <template #content>
              <p style="width: 350px;">
                Uploading your StoreID helps us provide you with more high-quality ACC Campaign opportunities from brands, helping you earn more ACC commissions.
              </p>
            </template>
            <Icon name="a-warring-tianchong3" class="wenhao-icon" />
          </a-popover>
        </div>

      </div>
      <artmisads-segmented-tabs :disabled="loading" :showTitle="false" v-model="activeTab" :items="programConfig" />
      <div class="content-table">
        <div class="table-header">
        
           <!-- <artmisads-button type="primary"
             disabled>Upload</artmisads-button>
           <a-popover placement="left">
              <template #content>
              <p>Sorry, report uploads are temporarily unavailable due to Amazon policy updates. This will be fixed soon.</p>
             
              </template>
              <Icon name="wenhao-tianchong" class="wenhao-icon" />
          </a-popover> -->
          <a-popover v-if="programConfig[activeTab].uploadDisabled" placement="left" :open="true">
            <template #content>
              <p>Please set up your Amazon Associate Tags before uploading data reports.</p>
              <a style="text-decoration: underline;" @click="handleSetUp">Set Up Now. </a>

            </template>

            <artmisads-button type="primary"
              :disabled="programConfig[activeTab].uploadDisabled">Upload</artmisads-button>
          </a-popover>
          <artmisads-button v-else type="primary" @click="handleUpload"
            :disabled="programConfig[activeTab].uploadDisabled">Upload</artmisads-button>
        </div>
        <artmisads-table :loading="loading" :columns="columns" :data-source="data" row-key="id"
          :scroll="{ y: tableScrollHeight }" :pagination="{
            total: tableTotal,
            current: params.page,
            pageSize: params.size,
            showTotal: (total, range) => `Total ${total} items`,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100', '200']
          }" :change="onChangePage">
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'uploadAt'">
              {{ formatDate(record.uploadAt) }}
            </template>
            <template v-if="column.dataIndex === 'transactionCycle'">
              {{ `${record.reportStartDate&&record.reportEndDate?record.reportStartDate+' ~ '+record.reportEndDate:'--'}` }}
            </template>
            <template v-if="column.dataIndex === 'action'">

              <div v-if="record.status.toUpperCase() === 'PROCESSING' || record.status.toUpperCase() === 'FAILURE'"
                :class="record.status.toUpperCase() === 'PROCESSING' ? 'uploading-text' : ''">
                {{ record.status.toUpperCase() === 'PROCESSING' ? 'Uploading' : 'Failure' }}
              </div>
              <artmisads-select-button size="small" @click="handleView(record)" v-else>View</artmisads-select-button>
            </template>
          </template>
        </artmisads-table>
      </div>
    </div>

    <view-model v-model:open="viewVisible" :batchId="currentBatchId" :marketplace="params.marketplace" />
    <upload-model v-model:open="uploadVisible" :marketplace="params.marketplace" @success="handleUploadSuccess" />


  </div>
</template>

<script setup>
import { ref, watch,onMounted} from 'vue'
import moment from 'moment'
import breadcrumbs from "~/components/breadcrumbs.vue"
import PulicReportNotice from "@/components/PulicReportNotice.vue"
import ViewModel from './components/viewModel.vue'
import UploadModel from './components/uploadModel.vue'
import { associateCentralApi } from '~/server/index'
import { useTableScrollHeight } from '@/utils/useTableScrollHeight'
import { useRouter,useRoute } from 'vue-router'
import Icon from "@/components/Icon.vue"

const router = useRouter()
const route = useRoute()
const { tableScrollHeight } = useTableScrollHeight({
  selector: '.content-table',
  bottomSpace: 155,
  minHeight: 200,
  maxHeight: 800,
  defaultHeight: 350
})
import { associateTagsApi } from '@/server/publisher/associateTags'
import { COUNTRY_BASE } from '~/contants/common'

const marketplace =ref(route.query.marketplace)

const showNotice = ref(true)
const closeNotice = () => {
  showNotice.value = false
}
const breadcrumbsData = {
  title: "Upload Reports",
  hasTitleIcon: true,
  color: "#4682FA",
  // hasTitleIcon: false,
  links: [
    {
      name: "Home",
      path: "/publisher/dashboard",
    },
    {
      name: "Campaigns",
      path: "/publisher/campaigns/index",
    },
    {
      name: "Upload Reports",
      path: "/publisher/campaigns/upload",
    },
  ],
}
const loading = ref(false)
const activeTab = ref('0')
const programConfig = ref([
  {
    label: 'amazon.com',
    name: 'amazon.com',
    icon: 'guoqi-us',
    key: '0',
    uploadDisabled: false
  },
  {
    label: 'amazon.ca',
    name: 'amazon.ca',
    icon: 'guoqi-ca',
    key: '1',
    uploadDisabled: false
  },
  {
    label: 'amazon.uk',
    name: 'amazon.co.uk',
    icon: 'guoqi-uk',
    key: '2',
    uploadDisabled: false
  },
  {
    label: 'amazon.de',
    name: 'amazon.de',
    icon: 'guoqi-de',
    key: '3',
    uploadDisabled: false
  },
  {
    label: 'amazon.fr',
    name: 'amazon.fr',
    icon: 'guoqi-fr',
    key: '4',
    uploadDisabled: false
  }
])
const formatDate = (date) => {
  if (date) {
    return moment(Number(date)).format('YYYY-MM-DD')
  }
  return '--'
}
const handleSetUp = () => {
  router.push('/publisher/associateCentral/associateTags')
}
// const showTitle = ref(false)
const data = ref([])
const tableTotal = ref(0)
const columns = [
  {
    title: 'ID',
    dataIndex: 'batchId',
    name: 'id',
    align: 'center',
  },
  {
    title: 'File Name',
    dataIndex: 'uploadFileName',
    name: 'uploadFileName',
    align: 'center',
  },
  {
    title: 'Upload Date',
    dataIndex: 'uploadAt',
    name: 'reportName',
    align: 'center',
  },
  {
    title: 'Selected Period',
    dataIndex: 'transactionCycle',
    name: 'transactionCycle',
    align: 'center',
  },
  {
    title: 'Action',
    dataIndex: 'action',
    name: 'action',

    align: 'center',

  }
]
const params = ref({
  page: 1,
  size: 10,
  marketplace: programConfig.value[activeTab.value].name
})
watch(activeTab, (newVal) => {
  params.value.marketplace = programConfig.value[newVal].name
  params.value.page = 1
  params.value.size = 10
},{immediate:false})
const goAssociateTags = () => {
  router.push('/publisher/settings/associateTags')
}
const getList = () => {
  loading.value = true
  associateCentralApi.getUploadReportsList(params.value).then(res => {
    data.value = res.data.data
    tableTotal.value = res.data.total
  }).finally(() => {
    loading.value = false
  })
}
const getData = () => {

  associateTagsApi.getAssociateAllTags({
    page: 1,
    size: 10,
  }).then(res => {

    if (res.data.length > 0) {
      res.data.forEach(item => {
        const country = COUNTRY_BASE.find(item2 => item2.countryCode === item.countryCode)
        country.tag = item.associateTags
        programConfig.value.forEach(item3 => {
          if (item3.name === country.host) {
            if (country.tag.length > 0) {
              item3.uploadDisabled = false
            } else {
              item3.uploadDisabled = true
            }
          }
        })

      })
    }

  })
}
watch(params, (newVal) => {
  
  if(marketplace.value === 'amazon.com'){
    activeTab.value = '0'
  }else if(marketplace.value === 'amazon.ca'){
    activeTab.value = '1'
  }else if(marketplace.value === 'amazon.co.uk'){
    activeTab.value = '2'
  }else if(marketplace.value === 'amazon.de'){
    activeTab.value = '3'
  }else if(marketplace.value === 'amazon.fr'){
    activeTab.value = '4'
  }
  params.value.marketplace = programConfig.value[activeTab.value].name
  getList()
  getData()

}, { deep: true, immediate: true })
const onChangePage = (data) => {
  params.value.page = data.current
  params.value.size = data.pageSize
}

const viewVisible = ref(false)
const currentBatchId = ref('')

const handleView = (record) => {
  currentBatchId.value = record.batchId
  viewVisible.value = true
}

const uploadVisible = ref(false)

const handleUpload = () => {
  uploadVisible.value = true
}

const handleUploadSuccess = () => {
  params.value.page = 1
  uploadVisible.value = false
  
  getList()
}


</script>

<style lang="less" scoped>
.tooltip-text {
  width: 250px;
}
.wenhao-icon {
  fill: var(--dark-4);
}
.upload-reports {
  padding: 0 16px;

  .uploading-text {

    color: var(--dark-2);
    font-size: 12px;
  }

  .content-wrapper {
    display: block !important;

    .top-title {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .top-title-left {
        display: flex;
        align-items: center;
      }

      .top-title-right {
        display: flex;
        align-items: center;
        gap: 10px;
      }

      .icon {
        width: 16px;
        height: 16px;
        margin-left: 8px;
      }

      .mt-10 {
        margin-top: 10px;
      }
    }
  }
}

.table-header {
  margin-bottom: 16px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  // margin-right: 60px;
}
</style>